import ReactDOM from "react-dom";
import "./index.css";
import Router from "./Routes";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import { cookiesName } from "./utils/cookies";

ReactDOM.render(
  <BrowserRouter>
    <CookieConsent
      location="bottom"
      buttonText="Entendi"
      cookieName={cookiesName}
      style={{ background: "#a58ab6", zIndex: "9999" }}
      buttonStyle={{
        color: "#ffffffff",
        background: "#166bc7",
        fontSize: "13px",
      }}
      expires={150}
    >
      Este site utiliza cookies para melhorar a experiência do usuário.
    </CookieConsent>
    <Router />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
